module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logs"
  }, [_c('table', {
    staticClass: "members-table"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('tr', [_vm._m(1)]) : _vm._l((_vm.logs), function(log) {
    return _c('tr', {
      key: log.id
    }, [_vm._o(_c('td', {
      staticClass: "profile"
    }, [_c('div', {
      staticClass: "img avatar",
      style: ({
        backgroundImage: 'url(' + log.actor_profile_picture + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "nickname"
    }, [_vm._v(_vm._s(log.actor))])]), 0, log.id), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dateReadable(log.created_at)))])])
  })], 2), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "small": "",
      "layout": "prev, pager, next",
      "total": _vm.totalItems,
      "page-count": _vm.totalPages,
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "current-change": _vm.fetch
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n        所有成员\n      ")]), _vm._v(" "), _c('th', [_vm._v("操作信息")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("时间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "loading-cell",
    attrs: {
      "colspan": "10"
    }
  }, [_c('div', {
    staticClass: "spinner-wrapper"
  }, [_c('i', {
    staticClass: "ppj-icon-spinner"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-895ad228"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/members/logs/index.vue
// module id = 937
// module chunks = 3